import { render, staticRenderFns } from "./RemoteInstructions.vue?vue&type=template&id=083b9922&scoped=true&"
import script from "./RemoteInstructions.vue?vue&type=script&lang=js&"
export * from "./RemoteInstructions.vue?vue&type=script&lang=js&"
import style0 from "./RemoteInstructions.vue?vue&type=style&index=0&id=083b9922&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083b9922",
  null
  
)

export default component.exports